// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.r-loading-spinner--SIs3J{transform-origin:center;animation:spinner_StKS--oevrg .75s infinite linear}@keyframes spinner_StKS--oevrg{100%{transform:rotate(360deg)}}`, "",{"version":3,"sources":["webpack://./src/common/components/LoadingIcon/LoadingIcon.module.scss"],"names":[],"mappings":"AAAA,0BACE,uBAAA,CACA,kDAAA,CAGF,+BACE,KACE,wBAAA,CAAA","sourcesContent":[".r-loading-spinner {\n  transform-origin: center;\n  animation: spinner_StKS 0.75s infinite linear;\n}\n\n@keyframes spinner_StKS {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"r-loading-spinner": `r-loading-spinner--SIs3J`,
	"rLoadingSpinner": `r-loading-spinner--SIs3J`,
	"spinner_StKS": `spinner_StKS--oevrg`
};
export default ___CSS_LOADER_EXPORT___;
